<template>
 
</template>

<script>

export default {
  title: "New",
  access_code: "MB_FORM01",
  created() {
      this.$router.push("/Builder/ModelBuilder/request")
  }
};
</script>

<style>
</style>